"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IEventOrChallengeOrMilestone = void 0;
var IEventOrChallengeOrMilestone;
(function (IEventOrChallengeOrMilestone) {
    IEventOrChallengeOrMilestone["Event"] = "event";
    IEventOrChallengeOrMilestone["Challenge"] = "challenge";
    IEventOrChallengeOrMilestone["Milestone"] = "milestone";
})(IEventOrChallengeOrMilestone || (exports.IEventOrChallengeOrMilestone = IEventOrChallengeOrMilestone = {}));
//# sourceMappingURL=event-or-challenge-or-milestone.js.map